
import { PredefinedAltActionOptions, PredefinedOptionType, SystemEvent } from '@/common/bot/enum';
import { canConnectToAgent } from '@/common/bot/lib';
import { AlternativeActionSelectedEvent, BaseSystemMessage } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CustomerSupportIcon,
  },
})
export default class AlternativeActionsMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  get hasDirectRequest () {
    return !!this.message.config?.directRequest;
  }

  get hasConnectToSupport () {
    return canConnectToAgent(this.message.config?.connect);
  }

  buildAlternativeActionEvent (selected: PredefinedAltActionOptions) {
    const $event: AlternativeActionSelectedEvent = {
      message: this.message,
      type: SystemEvent.ALTERNATIVE_ACTION,
      payload: { selected },
    };

    this.$emit('send:event', $event);
  }
}
